import React, { useEffect } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import LogicDetailsView from "./LogicDetailsView";
import { RootStateServiceLogicBuilder } from "../../store/service-logic-builder-slice";
import PageLoader from "../../../../common/ui/PageLoader";

const LogicDetailsViewWrapper = () => {
  const { logicId } = useParams();
  const navigate = useNavigate();
  const { loadData } = useOutletContext<{ loadData: () => Promise<any> }>();

  // Get logics from Redux
  const savedLogics = useSelector(
    (state: RootStateServiceLogicBuilder) =>
      state.serviceLogicBuilder.savedLogics
  );

  const logic = React.useMemo(() => {
    return savedLogics.find((l: any) => l.id === logicId);
  }, [savedLogics, logicId]);

  // Redirect if logic not found
  useEffect(() => {
    if (savedLogics.length > 0 && !logic) {
      navigate("/client/services/logic");
    }
  }, [logic, savedLogics.length, navigate]);

  if (!logic) {
    return <PageLoader />;
  }

  return (
    <LogicDetailsView
      logic={logic}
      onBack={() => navigate("/client/services/logic")}
      onEdit={() => {
        // Navigate back to logic builder where edit modal will be handled
        navigate("/client/services/logic");
      }}
      onUpdate={async () => {
        // Refresh data from API to update Redux state
        await loadData();
      }}
      onDelete={async () => {
        await loadData();
        navigate("/client/services/logic");
      }}
    />
  );
};

export default LogicDetailsViewWrapper;
